import { useState } from 'react'
import HidePasswordToggle from '@components/HidePasswordToggle'

const Password = ({
  name = 'password',
  label = 'Password',
  required = false,
  helperText,
  register,
  formState: { errors },
}: {
  name?: string
  label?: string
  helperText?: string
  required?: boolean
  register: any
  formState: any
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false)
  return (
    <div className="">
      <label
        className="block text-gray-700 font-semibold text-xs flex flex-row justify-between"
        htmlFor="password"
      >
        <text>{label}</text>
        <HidePasswordToggle
          isVisible={isPasswordVisible}
          toggle={() => setIsPasswordVisible(!isPasswordVisible)}
        />
      </label>

      <input
        className="border border-gray-400 p-2 rounded-md w-full font-semibold"
        type={isPasswordVisible ? '' : 'password'}
        id={name}
        {...register(name, { required })}
      />

      {helperText && (
        <p className={`text-xs font-bold`} style={{ color: '#a3a3a3' }}>
          {helperText}
        </p>
      )}
      {errors[name] && (
        <div className="text-red text-sm">{errors[name].message}</div>
      )}
    </div>
  )
}

export default Password
